// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1lPGx","choiceBoxes":"toolbarselects_choiceBoxes__3HfzP","simpleField":"toolbarselects_simpleField__29aS5"};